import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalFooter from 'react-bootstrap/ModalFooter'
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";

export default function RemoveModalView(props) {
	const {t, i18n} = useTranslation('modals');
	const saveEvent = (event) => {
		event.preventDefault();

		props.modalview.saveEvent(props.modalview.data);
	}

	const bodyProps = {
      dangerouslySetInnerHTML: { __html: t('removeuserfromcompany.body') },
    };
	
  return (
	<Form onSubmit={saveEvent}>	
  <Modal.Header closeButton>
    <Modal.Title>{props.modalview.header}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p {...bodyProps} />
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => props.onHideEvent()}>{t('global.cancel')}</Button>
    <Button variant="primary" type="submit">{t('removeuserfromcompany.save')}</Button>
  </Modal.Footer>
	</Form>	
  );
}